import { getCurrentUser, login, logout } from '@redux/auth/actions';
import { createSlice } from '@reduxjs/toolkit';
import { AUTH_TOKEN } from 'constants/keyNames';
import { DynamicObjectType } from 'types/commons';

export interface AuthState {
  token?: string | null;
  loading: boolean;
  currentUser: DynamicObjectType;
  loginError?: boolean | string;
  loginSuccess?: boolean | string;
  data?: DynamicObjectType;
  role?: string;
}

const initialState: AuthState = {
  token: localStorage.getItem(AUTH_TOKEN),
  loading: false,
  currentUser: {},
  data: {
    fullName: localStorage.getItem('fullName') || '',
    id: localStorage.getItem('id'),
  },
  role: null,
};

export const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(login.pending, (state) => {
        state.token = '';
        state.loading = true;
      })
      .addCase(login.fulfilled, (state, { payload }) => {
        state.token = payload.accessToken;
        state.currentUser = payload;
        state.loading = false;
      })
      .addCase(login.rejected, (state) => {
        state.token = '';
        state.loading = false;
      })
      .addCase(logout.fulfilled, (state) => {
        state.token = null;
      })
      .addCase(getCurrentUser.fulfilled, (state, { payload }) => {
        state.data = payload;
        state.role = payload.systemRoleName;
      });
  },
});

export default authSlice.reducer;
